module.exports = "/assets/archetype-autonomy.webp"